import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { AccountChildrenModalAccountFragmentDoc } from './AccountChildrenModal.generated'
import * as Types from './purchasePlus_graphql'

export const AccountChildrenButtonAccountFragmentDoc = gql`
  fragment AccountChildrenButtonAccount on Account {
    children {
      totalCount
    }
    ...AccountChildrenModalAccount
  }
  ${AccountChildrenModalAccountFragmentDoc}
` as unknown as DocumentNode<Types.AccountChildrenButtonAccountFragment, unknown>
